export default "__VITE_PUBLIC_ASSET__c4ab0568__"